export default "__VITE_ASSET__DffuI$BK__"